import { signIn, useSession } from "next-auth/react";
import Link from "next/link";
import React from "react";
import { OneColumnContainer } from "./ColumnContainers/OneColumnContainer";
import { ComponentContainer } from "./ComponentContainer";
import { ComponentHeader } from "./ComponentHeader";

export default function Protected(props) {
  const { data: session, status }: any = useSession();
  const accessToken = session?.accessToken;

  const email: any = session?.email;
  const emailVerified = session?.email_verified === true;

  const ShowMessage = () => (
    <OneColumnContainer>
      <ComponentContainer>
        <ComponentHeader text="Please login" />
        <div className="grid min-h-screen pt-10 text-center font-['Montserrat'] font-normal text-[12px] uppercase">
          <div className="">
            Please
            <a
              className="hover:cursor-pointer font-bold"
              onClick={(e) => {
                e.preventDefault();
                signIn("fusionauth");
              }}
            >
              &nbsp; log in&nbsp;
            </a>
            to view this page
          </div>
        </div>
      </ComponentContainer>
    </OneColumnContainer>
  );

  const ShowEmailVerificationMessage = () => (
    <OneColumnContainer>
      <ComponentContainer>
        <ComponentHeader text="Please login" />
        <div className="flex flex-col flex-1 grow h-full align-center text-center justify-center">
          <div className="text-2xl self-center">
            Please click on the link in the verification email, sent to{" "}
            <span className="text-green-400">{email}</span>
          </div>
          <div className="text-xl pt-10 font-serif text-center">
            If you haven't received the mail, please check your spam folder. Or
            reach out to us at{" "}
            <a className="text-orange-500" href="mailto:info@golfchamps.net">
              info@golfchamps.net
            </a>{" "}
            so that we can manually verify you
          </div>
        </div>
      </ComponentContainer>
    </OneColumnContainer>
  );

  if (status === "unauthenticated") {
    return ShowMessage();
  } else if (status === "authenticated") {
    if (emailVerified === false) {
      return ShowEmailVerificationMessage();
    } else return props.children;
  }
}
